var _g, _g2, _ellipse, _rect, _rect2, _rect3, _ellipse2, _g3, _rect4, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g6, _path18, _ellipse3, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessFormIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 527,
    viewBox: "0 0 466 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_i_577_29862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.301 218.197C356.746 205.407 389.947 208.29 402.755 209.524C415.562 210.758 416.725 193.236 405.675 190.631C394.625 188.026 374.586 189.371 364.203 186.966C353.82 184.562 366.954 171.668 352.807 170.114C338.66 168.56 309.408 169.999 300.688 169.683C286.99 169.187 279.962 185.739 303.96 186.49C310.578 186.697 311.905 201.402 289.567 197.363C275.549 194.828 248.045 194.77 242.323 201.241C239.04 204.954 240.178 214.93 245.822 220.438C250.014 224.53 263.347 225.328 268.57 226.274C280.823 228.493 278.401 240.402 274.223 242.854C264.336 248.657 237.2 237.706 236.473 253.639C236.151 260.68 260.841 261.817 270.965 261.731C295.794 261.52 312.108 263.741 313.253 255.239C314.402 246.704 297.824 252.465 298.641 241.972C299.069 236.489 297.924 224.839 308.56 225.45C293.998 224.613 355.701 235.472 356.301 218.197Z",
    fill: "url(#paint0_linear_577_29862)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_i_577_29862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.452 168.242C205.419 155.444 238.704 157.077 251.549 157.829C264.394 158.58 264.902 141.027 253.762 138.839C242.623 136.652 222.648 138.748 212.183 136.736C201.718 134.724 214.361 121.345 200.166 120.324C185.972 119.302 156.794 121.84 148.067 121.852C134.361 121.871 127.955 138.676 151.964 138.524C158.585 138.483 160.46 153.127 137.987 149.93C123.884 147.924 96.397 148.899 90.9209 155.581C87.779 159.415 89.2879 169.341 95.1331 174.633C99.4753 178.565 112.829 178.861 118.083 179.61C130.411 181.367 128.434 193.359 124.351 195.966C114.687 202.136 87.1618 192.213 87.0292 208.163C86.9707 215.211 111.686 215.419 121.799 214.952C146.603 213.808 162.989 215.414 163.816 206.875C164.646 198.303 148.294 204.683 148.719 194.167C148.942 188.672 147.363 177.073 158.015 177.284C143.431 176.995 205.496 185.527 205.452 168.242Z",
    fill: "url(#paint1_linear_577_29862)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.084933,
    rx: 29.9302,
    ry: 1.69732,
    transform: "matrix(-1 0 0 1 119.39 395.004)",
    fill: "#8699BF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.156 393.232C393.28 392.537 419.861 380.887 417.406 378.395C414.952 375.903 402.98 375.903 402.98 375.903C402.98 375.903 391.033 393.928 392.156 393.232Z",
    fill: "url(#paint2_linear_577_29862)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 153.202,
    height: 283.792,
    rx: 70,
    transform: "matrix(-1 0 0 1 297.449 121.736)",
    fill: "url(#paint3_linear_577_29862)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 153.202,
    height: 283.792,
    rx: 70,
    transform: "matrix(-1 0 0 1 309.965 121.736)",
    fill: "url(#paint4_linear_577_29862)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 80.4903,
    height: 5.09195,
    rx: 2.54598,
    transform: "matrix(-1 0 0 1 273.438 140.067)",
    fill: "url(#paint5_linear_577_29862)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.2042,
    ry: 14.2575,
    transform: "matrix(-1 0 0 1 233.534 385.16)",
    fill: "url(#paint6_linear_577_29862)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_577_29862)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.689,
    height: 202.32,
    rx: 12,
    transform: "matrix(-1 0 0 1 303.539 162.472)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_577_29862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 162,
    width: 142,
    height: 203
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 140.689,
    height: 202.32,
    rx: 12,
    transform: "matrix(-1 0 0 1 303.539 162.472)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_577_29862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.161,
    height: 38.6988,
    rx: 19.3494,
    transform: "matrix(-1 0 0 1 296.773 317.606)",
    fill: "url(#paint7_linear_577_29862)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.2042,
    ry: 14.2575,
    transform: "matrix(-1 0 0 1 277.495 336.956)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.7993,
    height: 5.77089,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 258.219 324.396)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.1986,
    height: 5.77089,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 258.219 333.901)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 22.3208,
    height: 4.07356,
    rx: 2.03678,
    transform: "matrix(-1 0 0 1 258.219 345.442)",
    fill: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.161,
    height: 38.6989,
    rx: 19.3494,
    transform: "matrix(-1 0 0 1 296.773 270.761)",
    fill: "url(#paint8_linear_577_29862)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.2042,
    ry: 14.2575,
    transform: "matrix(-1 0 0 1 277.495 290.11)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.7993,
    height: 5.77089,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 258.219 277.55)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.1986,
    height: 5.77087,
    rx: 2.88543,
    transform: "matrix(-1 0 0 1 258.219 287.055)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 22.3208,
    height: 4.07356,
    rx: 2.03678,
    transform: "matrix(-1 0 0 1 258.219 298.597)",
    fill: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.161,
    height: 38.6988,
    rx: 19.3494,
    transform: "matrix(-1 0 0 1 296.773 172.995)",
    fill: "url(#paint9_linear_577_29862)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.2042,
    ry: 14.2575,
    transform: "matrix(-1 0 0 1 277.495 192.344)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.7993,
    height: 5.77088,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 258.219 179.784)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.1986,
    height: 5.77088,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 258.219 189.29)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 22.3208,
    height: 4.07357,
    rx: 2.03678,
    transform: "matrix(-1 0 0 1 258.219 200.831)",
    fill: "#A1B8E3"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_577_29862)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.161,
    height: 38.6988,
    rx: 19.3494,
    transform: "matrix(-1 0 0 1 317.066 218.822)",
    fill: "url(#paint10_linear_577_29862)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.2042,
    ry: 14.2575,
    transform: "matrix(-1 0 0 1 297.788 238.172)",
    fill: "#FFB417"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.7993,
    height: 5.77089,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 278.512 225.611)",
    fill: "#FFB417"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.1986,
    height: 5.77089,
    rx: 2.88544,
    transform: "matrix(-1 0 0 1 278.512 235.117)",
    fill: "#FFB417"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 22.3208,
    height: 4.07357,
    rx: 2.03678,
    transform: "matrix(-1 0 0 1 278.512 246.658)",
    fill: "#FFB417"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.981 292.555C359.981 298.621 364.959 310.509 358.467 313.591C351.976 316.673 346.236 300.665 346.236 300.665C346.236 300.665 346.731 288.911 352.599 288.911C358.467 288.911 359.981 286.489 359.981 292.555Z",
    fill: "url(#paint11_linear_577_29862)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_577_29862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 288,
    width: 16,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.981 292.555C359.981 298.621 364.959 310.509 358.467 313.591C351.976 316.673 346.236 300.665 346.236 300.665C346.236 300.665 346.731 288.911 352.599 288.911C358.467 288.911 359.981 286.489 359.981 292.555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_577_29862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.356 295.272C359.833 296.339 352.699 301.988 351.52 303.323C350.34 304.659 350.07 308.15 349.393 307.789C348.716 307.429 349.393 297.188 349.393 297.188C349.393 297.188 360.88 294.204 360.356 295.272Z",
    fill: "#3D82F0",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.373 430.098C348.482 433.231 349.424 437.117 348.672 438.701C347.92 440.285 343.952 441.244 342.633 441.29C341.315 441.336 340.796 439.119 338.788 440.34C336.78 441.56 325.108 441.904 324.187 437.272C323.267 432.639 329.184 432.432 331.815 432.34C334.447 432.247 337.189 430.863 340.98 427.386C344.771 423.909 348.264 426.965 348.373 430.098Z",
    fill: "url(#paint12_linear_577_29862)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M333.682 434.634C332.987 433.072 334.88 431.266 335.36 431.207",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M330.512 434.593C330.284 432.728 331.593 432.074 332.117 432.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.902 436.69C289.63 439.813 290.093 443.786 289.154 445.266C288.215 446.746 284.161 447.212 282.846 447.097C281.532 446.981 281.286 444.718 279.145 445.683C277.005 446.648 265.377 445.563 265.026 440.852C264.675 436.142 270.573 436.659 273.196 436.89C275.819 437.12 278.708 436.082 282.893 433.095C287.078 430.107 290.174 433.567 289.902 436.69Z",
    fill: "url(#paint13_linear_577_29862)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.768 439.395C274.268 437.76 276.366 436.199 276.85 436.199",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.626 438.967C271.626 437.087 273.006 436.599 273.533 436.599",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.502 324.482C300.502 324.482 287.752 371.37 286.092 382.039C284.433 392.708 280.371 428.771 280.944 434.586C283.719 437.426 288.717 435.726 289.587 435.205C290.458 434.684 295.822 405.013 300.502 393.503C305.181 381.993 315.712 371.399 322.651 359.819C322.651 367.356 328.009 387.527 328.009 387.527C328.009 387.527 335.822 423.149 338.481 428.915C339.743 430.96 346.112 429.46 348.582 428.915C348.582 423.512 343.256 396.217 343.256 386.741C343.256 377.266 344.729 360.094 345.279 353.054C345.829 346.014 347.174 332.356 345.279 324.482C340.475 324.482 300.502 324.482 300.502 324.482Z",
    fill: "url(#paint14_linear_577_29862)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_577_29862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 280,
    y: 324,
    width: 69,
    height: 113
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.502 324.482C300.502 324.482 287.752 371.37 286.092 382.039C284.433 392.708 280.371 428.771 280.944 434.586C283.719 437.426 288.717 435.726 289.587 435.205C290.458 434.684 295.822 405.013 300.502 393.503C305.181 381.993 315.712 371.399 322.651 359.819C322.651 367.356 328.009 387.527 328.009 387.527C328.009 387.527 335.822 423.149 338.481 428.915C339.743 430.96 346.112 429.46 348.582 428.915C348.582 423.512 343.256 396.217 343.256 386.741C343.256 377.266 344.729 360.094 345.279 353.054C345.829 346.014 347.174 332.356 345.279 324.482C340.475 324.482 300.502 324.482 300.502 324.482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_577_29862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.375 393.003C329.375 388.414 327.019 350.912 326.478 352.451C325.937 353.99 321.722 362.301 321.722 362.301C321.722 362.301 329.375 397.593 329.375 393.003Z",
    fill: "#A1B8E3",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M326.352 352.472C325.692 355.25 323.152 359.11 321.979 361.411",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.328 332.316C339.348 333.925 327.677 340.773 312.639 338.028C305.208 336.672 300.429 334.898 298.285 332.316C298.285 331.044 300.087 325.694 300.59 323.648C301.093 321.601 345.978 330.345 342.328 332.316Z",
    fill: "url(#paint15_linear_577_29862)",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.05 224.815C323.05 224.815 321.328 228.164 318.41 229.586C315.492 231.008 314.033 231.704 314.033 231.704L315.274 236.534C315.274 236.534 312.962 243.636 314.033 246.031C315.105 248.425 318.41 250.016 320.333 252.151C322.256 254.286 324.035 261.529 324.035 261.529H336.711L337.285 252.151C337.285 252.151 340.666 238.619 334.93 231.704C329.194 224.789 323.05 224.815 323.05 224.815Z",
    fill: "url(#paint16_linear_577_29862)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_577_29862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 313,
    y: 224,
    width: 26,
    height: 38
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.05 224.815C323.05 224.815 321.328 228.164 318.41 229.586C315.492 231.008 314.033 231.704 314.033 231.704L315.274 236.534C315.274 236.534 312.962 243.636 314.033 246.031C315.105 248.425 318.41 250.016 320.333 252.151C322.256 254.286 324.035 261.529 324.035 261.529H336.711L337.285 252.151C337.285 252.151 340.666 238.619 334.93 231.704C329.194 224.789 323.05 224.815 323.05 224.815Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_577_29862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.752 250.876C321.952 250.876 326.944 248.032 327.904 247.06C328.865 246.088 319.905 256.6 320.653 258.274C321.243 259.595 323.349 259.999 322.021 259.999C317.229 259.999 315.552 250.876 318.752 250.876Z",
    fill: "#3D82F0",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.285 251.755C348.462 241.269 357.312 232.32 349.679 219.85C342.047 207.38 324.287 203.188 320.967 218.346C320.967 224.85 325.751 228.325 325.751 228.325C325.751 228.325 326.646 230.153 324.287 232.092C321.927 234.031 324.287 235.634 324.287 235.634C324.287 235.634 328.946 232.626 330.163 236.632C331.38 240.638 326.888 242.072 326.888 243.075C325.34 246.76 328.535 250.131 328.535 250.131C328.535 250.131 330.171 251.755 337.285 251.755Z",
    fill: "url(#paint17_linear_577_29862)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.815 265.9C348.815 265.9 360.78 286.968 362.224 291.604C363.667 296.24 348.815 298.921 348.815 298.921L342.617 272.42L348.815 265.9Z",
    fill: "url(#paint18_linear_577_29862)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.966 258.648C322.966 258.648 313.954 261.035 308.644 267.342C303.334 273.65 304.518 292.626 303.014 303.92C301.51 315.215 294.965 323.424 305.074 329.798C315.182 336.172 343.763 334.724 346.1 329.798C348.437 324.871 351.102 294.593 351.102 294.593C351.102 294.593 351.102 267.342 347.909 265.045C344.716 262.748 337.264 258.308 337.264 258.308C337.264 258.308 337.431 258.984 333.836 259.653C330.24 260.322 322.966 258.648 322.966 258.648Z",
    fill: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_577_29862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 299,
    y: 258,
    width: 53,
    height: 77
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.966 258.648C322.966 258.648 313.954 261.035 308.644 267.342C303.334 273.65 304.518 292.626 303.014 303.92C301.51 315.215 294.965 323.424 305.074 329.798C315.182 336.172 343.763 334.724 346.1 329.798C348.437 324.871 351.102 294.593 351.102 294.593C351.102 294.593 351.102 267.342 347.909 265.045C344.716 262.748 337.264 258.308 337.264 258.308C337.264 258.308 337.431 258.984 333.836 259.653C330.24 260.322 322.966 258.648 322.966 258.648Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_577_29862)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.48 280.205C315.48 280.205 310.62 303.011 307.695 307.286C304.77 311.56 302.868 324.495 300.527 326.038C298.186 327.58 294.822 309.935 296.504 303.893C298.186 297.852 305.765 283.054 305.765 283.054L315.48 280.205Z",
    fill: "url(#paint19_linear_577_29862)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.123 259.871C332.96 261.311 327.323 262.09 322.585 262.09C317.847 262.09 316.365 262.141 314.098 261.448C311.831 260.756 312.71 259.871 314.098 259.871C315.486 259.871 319.791 258.855 322.108 258.855C324.426 258.855 337.286 258.43 335.123 259.871Z",
    fill: "url(#paint20_linear_577_29862)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.674 258.648C337.674 258.648 337.953 255.159 337.953 254.034C337.953 252.909 328.619 254.498 321.902 255.129C321.173 257.935 321.302 258.121 321.302 258.648C321.302 258.911 322.98 261.169 332.005 260.437C335.299 260.17 337.674 258.648 337.674 258.648Z",
    fill: "#E1ECFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.1834,
    ry: 3.63884,
    transform: "matrix(-0.405466 -0.91411 -0.912978 0.408009 293.255 281.738)",
    fill: "#A1B8E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.383 272.075L283.944 275.975C283.944 275.975 275.573 253.553 275.065 250.644C274.557 247.734 276.808 243.627 277.172 242.163C277.535 240.699 277.476 237.254 276.46 235.993C275.444 234.732 275.176 235.183 274.416 234.993C273.657 234.803 269.153 225.105 268.642 223.887C268.131 222.669 267.22 221.904 266.294 222.31C265.367 222.716 265.454 223.8 265.82 224.758C266.186 225.717 268.24 231.096 268.008 232.032C267.775 232.969 264.156 234.18 263.146 234.802C262.136 235.424 260.416 237.468 261.276 240.426C262.135 243.384 266.103 248.746 265.82 249.886C265.536 251.026 269.542 270.35 270.817 278.079C272.092 285.807 273.759 291.227 280.267 290.78C286.775 290.333 300.262 283.069 300.262 283.069C300.262 283.069 299.38 277.427 297.695 275.298C296.01 273.169 293.383 272.075 293.383 272.075Z",
    fill: "url(#paint21_linear_577_29862)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_577_29862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 222,
    width: 40,
    height: 69
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.383 272.075L283.944 275.975C283.944 275.975 275.573 253.553 275.065 250.644C274.557 247.734 276.808 243.627 277.172 242.163C277.535 240.699 277.476 237.254 276.46 235.993C275.444 234.732 275.176 235.183 274.416 234.993C273.657 234.803 269.153 225.105 268.642 223.887C268.131 222.669 267.22 221.904 266.294 222.31C265.367 222.716 265.454 223.8 265.82 224.758C266.186 225.717 268.24 231.096 268.008 232.032C267.775 232.969 264.156 234.18 263.146 234.802C262.136 235.424 260.416 237.468 261.276 240.426C262.135 243.384 266.103 248.746 265.82 249.886C265.536 251.026 269.542 270.35 270.817 278.079C272.092 285.807 273.759 291.227 280.267 290.78C286.775 290.333 300.262 283.069 300.262 283.069C300.262 283.069 299.38 277.427 297.695 275.298C296.01 273.169 293.383 272.075 293.383 272.075Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_577_29862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.284 273.112C290.284 273.112 292.285 284.859 291.029 288.315C289.774 291.771 296.659 286.894 296.659 286.894C296.659 286.894 296.525 281.861 295.467 279.573C294.409 277.285 290.284 273.112 290.284 273.112Z",
    fill: "#3D82F0",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M284.141 275.696C283.609 275.941 282.602 276.322 281.699 277.577",
    stroke: "#223762",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.772 290.228C295.709 284.889 294.177 277.541 289.92 273.143C305.109 266.57 309.895 264.239 314.67 262.191C319.445 260.144 323.79 273.63 314.67 280.339C305.55 287.047 299.306 289.105 296.772 290.228Z",
    fill: "url(#paint22_linear_577_29862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_577_29862",
    x: 236.469,
    y: 155.377,
    width: 176.758,
    height: 106.467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788056 0 0 0 0 0.827193 0 0 0 0 0.89764 0 0 0 0.337126 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_577_29862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_577_29862",
    x: 87.0273,
    y: 106.082,
    width: 174.652,
    height: 109.021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788056 0 0 0 0 0.827193 0 0 0 0 0.89764 0 0 0 0.337126 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_577_29862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_577_29862",
    x: 0.851562,
    y: 0.47168,
    width: 464.688,
    height: 526.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 81
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_29862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_29862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_577_29862",
    x: 189.906,
    y: 218.822,
    width: 144.16,
    height: 55.6987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 17,
    dy: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.706613 0 0 0 0 0.0893703 0 0 0 0.173347 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_29862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_29862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_29862",
    x1: 295.73,
    y1: 249.66,
    x2: 286.329,
    y2: 186.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_577_29862",
    x1: 145.691,
    y1: 201.014,
    x2: 136.023,
    y2: 137.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_577_29862",
    x1: 418.213,
    y1: 377.863,
    x2: 411.658,
    y2: 398.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_577_29862",
    x1: 203.241,
    y1: -36.162,
    x2: 35.2918,
    y2: 4.40968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_577_29862",
    x1: 95.6985,
    y1: -91.2246,
    x2: -117.724,
    y2: 6.57075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_577_29862",
    x1: 12.7145,
    y1: 9.57832,
    x2: 119.719,
    y2: 9.57834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_577_29862",
    x1: 19.1374,
    y1: 45.0841,
    x2: 39.9623,
    y2: 15.7477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_577_29862",
    x1: 162.899,
    y1: 81.6682,
    x2: 158.975,
    y2: 22.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_577_29862",
    x1: 162.899,
    y1: 81.6682,
    x2: 158.975,
    y2: 22.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_577_29862",
    x1: 162.899,
    y1: 81.6682,
    x2: 158.975,
    y2: 22.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_577_29862",
    x1: 193.254,
    y1: 55.6913,
    x2: 185.132,
    y2: -1.12421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECC4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_577_29862",
    x1: 349.414,
    y1: 322.323,
    x2: 341.38,
    y2: 310.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D82F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_577_29862",
    x1: 347.065,
    y1: 446.385,
    x2: 337.221,
    y2: 431.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_577_29862",
    x1: 286.626,
    y1: 452.696,
    x2: 278.685,
    y2: 436.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_577_29862",
    x1: 312.446,
    y1: 459.689,
    x2: 265.242,
    y2: 352.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_577_29862",
    x1: 290.303,
    y1: 335.376,
    x2: 290.815,
    y2: 326.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3",
    stopOpacity: 0.477723
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_577_29862",
    x1: 315.234,
    y1: 215.572,
    x2: 332.35,
    y2: 227.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D82F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_577_29862",
    x1: 345.658,
    y1: 215.408,
    x2: 330.291,
    y2: 235.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_577_29862",
    x1: 360.72,
    y1: 294.878,
    x2: 345.367,
    y2: 292.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_577_29862",
    x1: 303.479,
    y1: 311.953,
    x2: 293.257,
    y2: 305.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_577_29862",
    x1: 283.115,
    y1: 265.946,
    x2: 283.257,
    y2: 256.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_577_29862",
    x1: 228.499,
    y1: 322.2,
    x2: 251.16,
    y2: 231.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D82F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_577_29862",
    x1: 324.806,
    y1: 270.424,
    x2: 314.605,
    y2: 291.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3EDFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFormIcon);
export default __webpack_public_path__ + "static/media/success-form-icon.d19e61bb6f4a32e7a8a2dbe5f8e34209.svg";
export { ForwardRef as ReactComponent };